import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { fbqPageView } from "@/lib/meta-pixel";

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    // Track SPA navigation as PageView in Meta Pixel
    fbqPageView();
  }, [pathname]);

  return null;
}
